(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/hooks/hooks.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/hooks/hooks.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useState = _React.useState;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory,
  useLocation = _ReactRouterDOM.useLocation;
const START = svs.ticket_partner.constants.routes.START;
const useLocalStorage = function (key) {
  let initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let expirationTimeMS = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  const _useState = useState(() => {
      try {
        const item = window.localStorage.getItem(key);
        const itemValue = item ? JSON.parse(item) : initialValue;
        const now = new Date().getTime();
        const hasExpired = expirationTimeMS && (itemValue === null || itemValue === void 0 ? void 0 : itemValue.exp) && itemValue.exp < now;
        if (hasExpired) {
          return initialValue;
        }
        return itemValue;
      } catch (error) {
        return initialValue;
      }
    }),
    _useState2 = _slicedToArray(_useState, 2),
    storedValue = _useState2[0],
    setStoredValue = _useState2[1];
  const setValue = useCallback(value => {
    setStoredValue(storedValue => {
      try {
        const valueToStore = typeof value === 'function' ? value(storedValue) : value;
        if (expirationTimeMS) {
          valueToStore.exp = new Date().getTime() + expirationTimeMS;
        }
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
        return valueToStore;
      } catch (error) {
        return storedValue;
      }
    });
  }, [key, expirationTimeMS]);
  return [storedValue, setValue];
};
const useReturnUrl = function () {
  let defaultRoute = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : START;
  const history = useHistory();
  const location = useLocation();
  const returnUrl = svs.utils.paramHandler.get({
    key: 'returnUrl'
  }).value;
  const route = Object.values(svs.ticket_partner.constants.routes).find(route => route === returnUrl);
  const redirectToStartPage = useCallback(() => {
    history.push(defaultRoute);
  }, [defaultRoute, history]);
  const redirectToReturnUrl = useCallback(() => {
    const redirectTo = route || defaultRoute;
    history.push(redirectTo);
  }, [route, defaultRoute, history]);
  const redirectToKeepReturnUrl = useCallback(to => {
    const redirectTo = to || defaultRoute;
    let search = '';
    if (route && redirectTo !== route) {
      search = "?returnUrl=".concat(route);
    }
    history.push("".concat(redirectTo).concat(search));
  }, [route, defaultRoute, history]);
  const redirectToWithBackReturnUrl = useCallback(to => {
    const redirectTo = to || defaultRoute;
    let search = '';
    if (redirectTo !== location.pathname) {
      search = "?returnUrl=".concat(location.pathname);
    }
    history.push("".concat(redirectTo).concat(search));
  }, [defaultRoute, history, location.pathname]);
  const redirectToKeepReturnUrlOrBack = useCallback(to => {
    const redirectTo = to || defaultRoute;
    if (route && redirectTo !== route) {
      redirectToKeepReturnUrl(redirectTo);
    } else {
      redirectToWithBackReturnUrl(redirectTo);
    }
  }, [defaultRoute, route, redirectToKeepReturnUrl, redirectToWithBackReturnUrl]);
  return {
    returnUrl: route,
    redirectToStartPage,
    redirectToReturnUrl,
    redirectToKeepReturnUrl,
    redirectToWithBackReturnUrl,
    redirectToKeepReturnUrlOrBack
  };
};
const useBreakpointGreaterThan = breakpoint => {
  const _useState3 = useState(svs.core.detect.breakpoint.greaterThan(breakpoint)),
    _useState4 = _slicedToArray(_useState3, 2),
    greaterThan = _useState4[0],
    setGreaterThan = _useState4[1];
  useEffect(() => {
    const onBreakPointChange = () => {
      setGreaterThan(svs.core.detect.breakpoint.greaterThan(breakpoint));
    };
    svs.core.detect.breakpoint.on('change', onBreakPointChange);
    return () => {
      svs.core.detect.breakpoint.off('change', onBreakPointChange);
    };
  }, [breakpoint]);
  return [greaterThan];
};
const usePromiseDeferred = () => {
  const _useState5 = useState(() => {
      const p = {};
      p.promise = new Promise((resolve, reject) => {
        p.resolve = resolve;
        p.reject = reject;
      });
      return p;
    }),
    _useState6 = _slicedToArray(_useState5, 1),
    promise = _useState6[0];
  return promise;
};
svs.ticket_partner.sharedComponents.hooks = {
  useReturnUrl,
  useLocalStorage,
  useBreakpointGreaterThan,
  usePromiseDeferred
};

 })(window);